<template>
  <div
    :class="[
      $style.newBuildingProjectCardSticky,
      isHidden ? $style.isHidden : '',
      isPlatformIs24() ? $style.isPlatformIs24 : '',
    ]"
  >
    <HgButton theme="ghost" @click="emit('click', $event)">
      <HgIcon icon="InfoCircle" theme="dark" size="large" />
      {{ t('$domus.badge.newConstruction.long') }}
    </HgButton>
  </div>
</template>

<script lang="ts" setup>
import { HgButton, HgIcon } from '@smg-real-estate/domus';

import { isPlatformIs24 } from '@/helpers/platformDetection';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineOptions({
  name: 'NewBuildingProjectCardSticky',
});

interface Props {
  isHidden?: boolean;
}
withDefaults(defineProps<Props>(), {
  isHidden: false,
});

const emit = defineEmits<{
  click: [$event: unknown];
}>();
</script>

<style lang="scss" module>
@import '@/assets/variables';

$sticky-cta-height: 54px;
$sticky-cta-spacing: $space-75;

.newBuildingProjectCardSticky {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: $sticky-cta-height;
  padding: $sticky-cta-spacing;
  background-color: #ffc986;
  transition:
    top $transition-duration $transition-easing,
    left $transition-duration $transition-easing;

  button {
    min-width: 100%;

    span {
      display: flex;
      gap: $space-25;
      align-items: center;
      color: $color-grey-120;
      text-decoration: underline;
    }

    &:focus {
      outline: none;
    }
  }

  &.isHidden {
    top: -$sticky-cta-height;
  }

  &.isPlatformIs24 {
    background-color: $color-teal-60;
  }
}
</style>
